import { DiscountOriginType, EffectiveCart } from 'interfaces/cart';
import sum from 'lodash/sum';

/**
 * Sums item-level discounts that belong to a specific discount origin.
 *
 * The match is done by origin type first, then by the origin index referenced by
 * each item discount entry. Discount amounts are multiplied by line quantity.
 */
export const getOriginItemsDiscountAmount = (
  effectiveCart: EffectiveCart,
  originType: DiscountOriginType
): number => {
  const discountOrigin = effectiveCart.discountOrigins?.find(
    (origin) => origin.type === originType
  );

  if (!discountOrigin || !discountOrigin.items) {
    return 0;
  }

  const discountOriginIndex = effectiveCart.discountOrigins!.indexOf(discountOrigin);

  const discounts = discountOrigin.items
    .map((variantId) => effectiveCart.items?.find((cartItem) => cartItem.variantId === variantId))
    .map((item) => {
      const discount = item?.discounts?.find((entry) => entry.originIndex === discountOriginIndex);
      return discount ? discount.amount * item!.quantity : 0;
    });

  return sum(discounts);
};
